/**
 * An interface for calling a generic function with deferred arguments.
 *
 * Types are correctly inferred for up to 3 overloaded signatures of `fn`,
 * but you may need to pass a custom callback with narrower argument types
 * if TSC gives you a type error for something you expected to check.
 */
export interface Thunk {
  <T extends Fn>(fn: T, ...args: MultipleParameters<T>): () => ReturnType<T>;
}

type Fn<TArgs extends any[] = any[]> = (...args: TArgs) => any;

type MultipleParameters<T extends Fn> = T extends {
  (...args: infer A1): any;
  (...args: infer A2): any;
  (...args: infer A3): any;
}
  ? A1 | A2 | A3
  : T extends { (...args: infer A1): any; (...args: infer A2): any }
  ? A1 | A2
  : T extends { (...args: infer A1): any }
  ? A1
  : never;
